import {Injectable} from '@angular/core';
import {filter, map, tap} from 'rxjs/operators';
import 'rxjs/add/operator/catch';
import {BasicEpic} from './basic.epic';
import {PollActions} from '../actions/poll.actions';
import {PollService} from '../services/poll.service';
import {EventObject, EventService, StoreActionsEnum, StoreEventsEnum} from '../../../modules/hbs-services';
import {ToastService} from 'ng-uikit-pro-standard';
import {Router} from '@angular/router';

@Injectable()
export class PollEpics extends BasicEpic {
    // epicNames must list epics that are handled
    protected epicNames = [
        'loadEntirePoll',
        'updateBtPoll',
        'deletePoll',
        'deletePollResults',
        'insertBtPoll',
        'publishPoll',
        'unpublishPoll',
        'copyPoll',
        'emailResponsesToMe',
        'changePollAudience'
    ];

    constructor(private router: Router,
                private pollService: PollService,
                private eventService: EventService,
                private toastService: ToastService) {
        super();
    }

    private loadEntirePoll = BasicEpic.createEpic(
        StoreActionsEnum.LOAD_ENTIRE_POLL,
        ({payload}) => {
            return this.pollService
                .loadEntirePoll(payload.pollId)
                .pipe(
                    map(PollActions.entirePollLoaded)
                );
        });

    private insertBtPoll = BasicEpic.createEpic(
        StoreActionsEnum.INSERT_BTPOLL,
        ({payload}) => {
            return this.pollService
                .insertBtPoll(payload.poll, payload.isPublic)
                .pipe(
                    filter(data => {
                        // console.log('filter: data', data);
                        if (data && data['_isValidation']) {
                            return false;
                        }
                        this.eventService.emit(new EventObject(StoreEventsEnum.CLOSE_EDIT_POLL));
                        this.router.navigate(['/author/edit', data.status.pollId], {});

                        return true;
                    }),
                    map(PollActions.pollInserted)
                );
        });

    private updateBtPoll = BasicEpic.createEpic(
        StoreActionsEnum.UPDATE_BTPOLL,
        ({payload}) => {
            return this.pollService
                .updateBtPoll(payload.poll, payload.pollId, payload.updateAllFields)
                .pipe(
                    filter(data => {
                        // console.log('filter: data', data);
                        if (data && data['_isValidation']) {
                            return false;
                        }
                        this.eventService.emit(new EventObject(StoreEventsEnum.CLOSE_EDIT_POLL));
                        return true;
                    }),
                    tap(data => {
                        if (payload.effect && payload.effect.toast) {
                            this.toastService.info(payload.effect.toast);
                        }
                    }),
                    map(PollActions.btPollLoaded)
                );
        });

    private publishPoll = BasicEpic.createEpic(
        StoreActionsEnum.PUBLISH_POLL,
        ({payload}) => {
            return this.pollService
                .publishPoll(payload.pollId)
                .pipe(
                    // tap(action => console.log('before: PollActions.publishPoll', action)),
                    map(PollActions.pollPublished)
                );
        });

    private unpublishPoll = BasicEpic.createEpic(
        StoreActionsEnum.UNPUBLISH_POLL,
        ({payload}) => {
            return this.pollService
                .unpublishPoll(payload.pollId)
                .pipe(
                    // tap(action => console.log('before: PollActions.unpublishPoll', action)),
                    map(PollActions.pollUnpublished)
                );
        });

    private deletePoll = BasicEpic.createEpic(
        StoreActionsEnum.DELETE_POLL,
        ({payload}) => {
            return this.pollService
                .deletePoll(payload.pollId)
                .pipe(
                    // tap(data => console.log('before: PollActions.pollDeleted', data)),
                    tap(data => this.toastService.info(`Poll ${payload.pollId} has been deleted`)),
                    tap(data => this.eventService.emit(new EventObject(StoreEventsEnum.POLL_DELETED, {pollId: payload.pollId}))),
                    map(data => PollActions.pollDeleted(payload.pollId))
                );
        });

    private deletePollResults = BasicEpic.createEpic(
        StoreActionsEnum.DELETE_POLL_RESULTS,
        ({payload}) => {
            return this.pollService
                .deletePollResults(payload.pollId)
                .pipe(
                    // tap(action => console.log('before: PollActions.deletePollResults', action)),
                    tap(action => this.toastService.info(`Poll ${payload.pollId} responses have been deleted`)),
                    tap(action => this.eventService.emit(new EventObject(StoreEventsEnum.POLL_RESULTS_DELETED, {pollId: payload.pollId}))),
                    map(data => PollActions.pollResultsDeleted(payload.pollId))
                );
        });

    private changePollAudience = BasicEpic.createEpic(
        StoreActionsEnum.CHANGE_POLL_AUDIENCE,
        ({payload}) => {
            return this.pollService
                .changePollAudience(payload.pollId, payload.makePublic)
                .pipe(
                    tap(action => this.toastService.info(`Poll ${payload.pollId} audience has changed`)),
                    map(PollActions.entirePollLoaded)
                );
        });

    private copyPoll = BasicEpic.createEpic(
        StoreActionsEnum.COPY_POLL,
        ({payload}) => {
            return this.pollService
                .copyPoll(payload.pollId, payload.title)
                .pipe(
                    // tap(data => console.log('before: PollActions.pollCopied', data)),
                    tap(data => this.toastService.info(`Created copy of Poll ${payload.pollId}`)),
                    tap(data => this.eventService.emit(new EventObject(StoreEventsEnum.POLL_COPIED, {
                        origPollId: payload.pollId,
                        records: data.records
                    }))),
                    map(PollActions.NONE)
                );
        });


    private emailResponsesToMe = BasicEpic.createEpic(
        StoreActionsEnum.EMAIL_RESPONSES_TO_ME,
        ({payload}) => {
            return this.pollService
                .emailResponsesToMe(payload.pollId)
                .pipe(
                    // tap(data => console.log('before: PollActions.emailResponsesToMe', data)),
                    tap(data => this.toastService.info(`Poll ${payload.pollId} responses have been emailed to you`)),
                    tap(data => this.eventService.emit(new EventObject(StoreEventsEnum.EMAILED_RESPONSES_TO_ME, data))),
                    map(PollActions.NONE)
                );
        });

}
